<template>
    <div
            v-bind:class="{ success: success, help: help, blapp: true }">
        <img
                alt="Vue logo"
                src="../assets/logo.png"
                v-on:click="reset"
        >
        <h1 class="queenCount">
            {{queenCount}} Queens live together in perfect harmony.
        </h1>
        <h2 v-if="!success">Can 8 fit?</h2>
        <h2 v-if="success">It's a miracle!</h2>
        <div class="helpVisibilityButtonContainer">
            <img
                    v-if="help"
                    src="../assets/hide.svg"
                    alt="hide help"
                    v-on:click="toggleHelp"
            >
            <img
                    v-if="!help"
                    src="../assets/show.svg"
                    alt="show help"
                    v-on:click="toggleHelp"
            >
        </div>
        <div class="grid">
            <div
                    v-bind:class="{ black: (square.x + square.y) % 2 === 0, red: square.danger, queen: square.queen, square}"
                    v-for="square in grid"
                    v-bind:key="square.i"
                    v-on:click="() => onSquareClick(square.i)"
            >
                <img
                        v-if="square.queen"
                        src="../assets/queen.svg"
                        alt="queen"
                >
            </div>

        </div>
    </div>
</template>

<script>
    const getBlankGrid = () => {
        const sideLength = 8;
        let i = 0;
        const squares = [];
        for (let x = 0; x < sideLength; x++) {
            for (let y = 0; y < sideLength; y++) {
                squares.push({
                    i,
                    x,
                    y,
                    queen: false,
                    danger: false,
                });
                i++;
            }
        }
        return squares;
    };

    const computeDanger = grid => {
        let dangerIndexes = [];
        for (let i = 0; i < 64; i++) {
            let square = grid[i];
            if (!square.queen) continue;
            for (let j = 0; j < 64; j++) {
                if (isOrthogonal(grid[i], grid[j]) || isDiagonal(grid[i], grid[j]))
                    dangerIndexes[j] = true;
            }
        }
        grid.forEach((square, i) => square.danger = dangerIndexes[i])
    };

    const isOrthogonal = (a, b) => a.x === b.x || a.y === b.y;

    const isDiagonal = (a, b) => Math.abs(a.x - b.x) === Math.abs(a.y - b.y);

    const computeSuccess = grid => {
        let queenCount = 0;
        for (let i = 0; i < 64; i++) {
            if (grid[i].queen) {
                queenCount++;
            }
        }
        return queenCount;
    };

    export default {
        name: 'Grid',
        props: {
            msg: String
        },
        data: () => {
            return ({
                    grid: getBlankGrid(),
                    help: false,
                    success: false,
                    queenCount: 0
                }
            )
        },
        methods: {
            reset: function () {
                this.grid = getBlankGrid();
                this.queenCount = 0;
                this.success = false;
            },
            toggleHelp: function () {
                this.help = !this.help;
            },
            onSquareClick: function (i) {
                let square = this.grid[i];
                if (!square.danger || square.queen) {
                    square.queen = !square.queen;
                    computeDanger(this.grid);
                    const queenCount = computeSuccess(this.grid);
                    this.success = queenCount > 7;
                    this.queenCount = queenCount;
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .blapp {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;

        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
    }

    a {
        color: #42b983;
    }

    .helpVisibilityButtonContainer {
        height: 3rem;
        margin-bottom: 20px;
    }

    .helpVisibilityButtonContainer img {
        height: 100%;
        cursor: pointer;
    }

    .success .grid {
        pointer-events: none;
    }

    .grid {
        border: 1px solid black;
        height: 50vh;
        width: 50vh;
        max-height: 50vw;
        max-width: 50vw;

        display: grid;
        grid-template-columns: repeat(8, 1fr);
        grid-template-rows: repeat(8, 1fr);
    }

    @media (max-width: 800px) {
        .blapp h1,
        .blapp h2 {
            margin: .5rem 0;
        }

        .grid {
            border: none;
            height: calc(100vh - 20px);
            width: calc(100vh - 20px);
            max-height: calc(100vw - 20px);
            max-width: calc(100vw - 20px);
        }

        .blapp > img {
            max-height: 10vh;
        }

    }

    .blapp > img {
        cursor: pointer;
    }

    .success > img {
        animation: jiggle .2s infinite;
    }

    @keyframes jiggle {
        0% {
            transform: rotate(-3deg);
        }
        50% {
            transform: rotate(3deg)
        }
        100% {
            transform: rotate(-3deg);
        }
    }

    .square {
        border: 1px solid black;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .square:not(.red),
    .square.queen {
        cursor: pointer;
    }

    .square img {
        height: 80%;
        width: 80%;
    }

    .black {
        background-color: darkgray;
    }

    .help .red {
        background-color: hotpink;
    }

    .help .black.red {
        background-color: deeppink;
    }

</style>
